/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-03-12 21:51:58
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare ကို ဖွင့်ပါ",
    name2: "ကြိုတင်စာရင်းပေးခြင်းတစ်ခု ပြုလုပ်ပါ",
    name3: "Carlcare ဖြင့် သင်သည် မှာယူမှုများကို အချိန်မရွေး စစ်ဆေးနိုင်ပါသည်။",
    name4: "",
    name5: "ညာသို့ ပွတ်ဆွဲပါ",
    name6: "အတည်ပြုပြီးပါပြီ",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02130204983.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
  },
  order: {
    name1: "စက်၏ မော်ဒယ်ကို ရွေးချယ်ပါ",
    name2: "ချွတ်ယွင်းမှု ဖော်ပြချက်-",
    name3: "ဖုန်းပြင်ဆိုင် ရွေးချယ်ရန် တို့ပါ",
    name4: "ဖုန်းပြင်ဆိုင်-",
    name5: "ချိန်းဆိုထားချိန်-",
    name6: "သင့်စက်၏ ပြဿနာကို အသေးစိတ် ဖော်ပြပေးပါ။",
    name7: "ရောက်ရှိချိန် ရွေးချယ်ရန် တို့ပါ",
    name8: "ကျွန်ုပ်တို့က သင့်အား ဆက်သွယ်နိုင်စေရန် သင်၏ ဆက်သွယ်ရန်လိပ်စာမှန် အသေးစိတ်ကို ရိုက်ထည့်ပေးပါ",
    name9: "ရနိုင်သော ကြိုတင်စာရင်းပေးသွင်းချိန်မှာ အောက်ပါအတိုင်းဖြစ်သည်",
    name10: "ကျေးဇူးပြု၍ သင့်ဖုန်းနံပါတ်ကို ထည့်သွင်းပါ",
    name11: "ဈေးနှုန်း",
    name12: "ကိုယ်ရေး အချက်အလက်များ-",
    name13: "သင့်အမည် ထည့်ပေးပါ",
    name14: "တင်သွင်းသည်",
    name15: "မလုပ်တော့",
    name16: "အိုကေ",
  },
  shops: {
    name1: "သင်ရွေးချယ်သော အမှတ်တံဆိပ်ပေါ်မူတည်ပြီး အောက်ပါ ဖုန်းပြင်ဆိုင်များက သင့်အား ဆောင်ရွက်ပေးနိုင်ပါသည်။",
    name2: "မကြာမီ လက်လီစတိုးဆိုင်များ နောက်ထပ် ရှိလာပါလိမ့်မည်၊ ကျွန်ုပ်တို့နှင့် ဆက်ရှိနေပေးပါ။",
  },
  price: {
    name1: "အမှတ်တံဆိပ်",
    name2: "မော်ဒယ်",
    name3: "ခု",
    name4: "ဈေးနှုန်း",
    name5: "ရင်းနှီးသော သတိပေးချက်:",
    name6: "ယင်းစျေးနှုန်းများမှာ ကိုးကားရန်သာဖြစ်ပြီး တကယ့်စျေးနှုန်းများမှာ သင့်စက်၏ အခြေအနေအတိုင်းပင် ဖြစ်သည်။",
    name7: "အကယ်၍ အထူးသင်္ကေတမရှိလျှင် တန်ဖိုးယူနစ်သည် နိုင်ငံတွင်း ငွေကြေးယူနစ် ဖြစ်သည်။",
    name8: "ဝမ်းနည်းပါတယ်။ လက်ရှိဒေသတွင် ရနိုင်သော စျေးနှုန်းအချက်အလက်မရှိပါ။",
    name11:"အလုပ်သမား စရိတ်",
    name12:"စုစုပေါင်း စျေးနှုန်း",
    name13: "5. ဝန်ထမ်းအား ပေးရသည့်စရိတ်သည် \"/\" ဖြစ်လျှင် ယင်းက ထိုစရိတ်ကို ဖုန်းပြင်ဆိုင်နှင့် တိုင်ပင်ဆွေးနွေးရန် လိုအပ်သည်ဟု ဆိုလိုသည်။",
    item_main_board: "မိန်းဘုတ်",
    item_screen_frame: "စခရင် (ဖရိမ်)",
    item_screen_screen_frame: "ဒုတိယ စခရင် (ဖရိမ်)",
    item_touch_screen: "တို့ထိသုံး စခရင်",
    item_camera: "ကင်မရာ",
    item_fixed_focus_camera: "ဆုံချက်အသေထား ကင်မရာ",
    item_auto_focus_camera: "အော်တို ဆုံချက်ဖမ်း ကင်မရာ",
    item_screen: "စခရင်",
    item_secondary_screen: "ဒုတိယ စခရင်",
    item_fingerprint_module: "လက်ဗွေ မော်ဂျူး",
    item_speaker: "စပီကာ",
    item_receiver: "ရဆိဗာ",
    item_small_board: "ဘုတ်အသေး",
    item_battery_cover: "ဘက်ထရီ ကာဗာ",
    item_battery: "ဘက်ထရီ",
    item_charger: "အားသွင်းကိရိယာ",
    item_usb_cable: "USB ကေဘယ်ကြိုး",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "ဒေတာ မရှိပါ",
    name2: "ဝန်ဆောင်မှု ပံ့ပိုးသူ-",
    name3: "ပြုပြင်မည့် အမှတ်တံဆိပ်-",
    name4: "တယ်လီဖုန်း-",
    name5: "အမှာစာ အရေအတွက်",
    name6: "ဆားဗစ် အဆင့်သတ်မှတ်ချက်",
    name7: "ဖုန်းပြင်ဆိုင် ပတ်ဝန်းကျင်-",
    name8: "ဆားဗစ်ပေးသည့် သဘောထား-",
    name9: "ဆားဗစ်ပိုင်း စွမ်းဆောင်နိုင်မှု-",
    name10: "ဆားဗစ် အရည်အသွေး-",
    name11: "ဖောက်သည် အကဲဖြတ်မှု",
    name12:"မှ",
    name13:"ပိတ်လိုက်ပါပြီ",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Carlcare ကို ဖွင့်ပါ",
    name1: "ကြိုတင်စာရင်းပေးသွင်းသည့် အချက်အလက်ကို စခရင်ပုံရိုက်ယူပြီး ယင်းအား ဦးစားပေး ဝန်ဆောင်မှုကို သုံးရာတွင် လက်ခံအဖြစ် သိမ်းထားပါ။",
    name2: "အောင်မြင်စွာ ပို့လိုက်ပါပြီ",
    name3: "1. ဒေတာကို ရှင်းလင်းပါ",
    name4: "သင့်ဖုန်းပေါ်ရှိ အရေးကြီးသော ကိုယ်ပိုင်ဒေတာများကို ကြိုတင်၍ အရန်သိမ်းထားပေးပါ",
    name5: "2.ပါဝါဖွင့်စကားဝှက်ကို ပိတ်ပါ",
    name6: "ဖုန်းပြင်ဆိုင်သို့ မသွားမီ အောက်ပါတို့ကို ဆောင်ရွက်ပေးပါ-",
    name7: "ဖုန်းပြင်ဆိုင်-",
    name8: "ချိန်းဆိုထားချိန်-",
    name9: "ချွတ်ယွင်းမှု ဖော်ပြချက်-",
    name10: "စက်မော်ဒယ်-",
    name11: "အမှာစာ နံပါတ်-",
    name12: "အမှာစာ အချက်အလက်များ",
  },
  title: {
    
    name1: "အောက်ပါနိုင်ငံများကို ပံ့ပိုးပေးပါသည်-",
    name2: "မော်ဒယ် ရွေးပါ",
    name3: "ကြိုတင်စာရင်းပေးခြင်း",
    name4: "ဖုန်းပြင်ဆိုင်အကြောင်း အသေးစိတ်",
    name5: "ဖုန်းပြင်ဆိုင် ရွေးချယ်ပါ",
  },
  error: {
    
    name1: "ဒေတာ မရှိပါ။ သင်၏ ပြုပြင်ရေးဆိုင်ရာ အချက်အလက်ကို စစ်ပေးပါ",
    name2: "နောက်ထပ် အကူအညီ လိုပါသလား။ ကွျန်ုပ်တို့ထံ ဆက်သွယ်ပေးပါ။",
    name3: "ဝမ်းနည်းပါတယ်၊ လက်ရှိ ဒေသတွင် Carlcare စင်တာ မရှိပါ။",
    name4: "ဆားဗစ်စင်တာတစ်ခုကို ဦးစွာ ရွေးပေးပါ",
    name5: "မအောင်မြင်ပါ",
    name6: "စက်မော်ဒယ်ကို ဦးစွာ ရွေးချယ်ပေးပါ",
    name7: "အသေးစိတ်အချက်အလက်",
    name8: "သင့်လိုအပ်ချက်များကို အသေးစိတ် ဖော်ပြပေးပါ",
    name9: "",
  },
  add1:{
    "name0": "my-rMM",
    "name1": "သင့်အော်ဒါကို အတည်ပြုလိုက်ပါပြီ။ သင့်ရောက်ရှိလာမှာကို မျှော်လင့်နေပါတယ်။",
    "name2": "မြို့ ရွေးပါ",
    "name3": "ကိန်း %1$s လုံးပါသည့် ဖုန်းနံပါတ်တစ်လုံး ရိုက်ထည့်ပေးပါ။",
    "name4": "အပတ်စဉ် နာရီများ",
    "name5": "တနင်္လာ",
    "name6": "အင်္ဂါ",
    "name7": "ဗုဒ္ဓဟူး",
    "name8": "ကြာသပတေး",
    "name9": "သောကြာ",
    "name10": "စနေ",
    "name11": "တနင်္ဂနွေ",
    "name12": "နိုင်ငံ ရိုက်ထည့်၍ ရှာပါ"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "အခြား",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"ပြန်ညွှန်းရန် တို့ပါ",
    name3:"အော်ဒါကို အဆင့်သတ်မှတ်ရန် Carlcare အက်ပ်ကို ဖွင့်ပါ",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"ဆားဗစ်ကို ရွေးပါ",
    name7:"အခမဲ့ သန့်ရှင်းရေးလုပ်ခြင်း",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "အချက်အလက် မှားနေပါသည်",
    "cancelReason1": "အချိန်မီ မရောက်နိုင်ပါ",
    "cancelReason2": "အမှာစာနံပါတ် ထပ်နေသည်/ကျွန်ုပ်၏ဟာ မဟုတ်ပါ",
    "cancelReason3": "မအောင်မြင်ကြောင်း ထပ်တလဲလဲမပေါ်ပါ",
    "cancelReason4": "အစမ်းသုံးရန်/စုံစမ်းရန်/ပွဲ/…အတွက်သာ",
    "cancelReason5": "စျေးကြီးသည်",
    "cancelReason6": "ပစ္စည်း ပြတ်လတ်နေသည်",
    "cancelReason7": "ကွဲပြားသော ဝန်ဆောင်မှုများ မရှိပါ",
    "cancelReason8": "ဖုန်းပြင်ဆိုင်မှာ ဝေးလွန်းသည်",
    "cancelReason9": "ဆိုင် ပိတ်သွားပါပြီ",
    "cancelReason10": "ဝန်ဆောင်မှုပိုင်း သဘောထားဆိုးသည်",
    "cancelReason11": "အခြားတံဆိပ်များအတွက် အစားထိုးလဲခြင်း/ပြုပြင်ခြင်း",
    "cancelReason12": "ဖုန်းပြင်ဆိုင်ကို ရှာ၍မရပါ",
    "cancelReason13": "အခြား",
    "cancelOrder": "အမှာစာကို ပယ်ဖျက်ပါ",
    "reason_dialog_title": "ပယ်ဖျက်ရသည့် အကြောင်းရင်းကို ပြောပြပေးပါ",
    "Cancel": "မလုပ်တော့",
    "OK": "အိုကေ",
    "name1": "အတည်ပြုကုဒ်ကို ဖြည့်ပါ",
    "name2": "အတည်ပြုကုဒ် မှားနေသည်",
    "repair_reservation_detail_canceled": "ဤအမှာစာကို ပယ်ဖျက်လိုက်ပါပြီ။",
    "purchase_cancel_dialog_content": "ဤအော်ဒါပယ်ဖျက်ရန် သင်အတည်ပြုပါသလား။",
    "yes": "ဟုတ်ကဲ့",
    "no": "ဟင့်အင်း"
}
};
